module.exports = __webpack_public_path__ + "static/media/washington-dc-67.3ee1a951.jpg";